var _image, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "83px",
    height: "112px",
    viewBox: "0 0 83 112",
    enableBackground: "new 0 0 83 112",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    enableBackground: "new    ",
    width: 84,
    height: 104,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFUAAABpCAYAAABLTW+MAAAACXBIWXMAAAs6AAALOgFkf1cNAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFJREFUeNrsnYuOozAMRe00///J 9WhW2hXLxK8kaDC9llADggCHG9uhEiaCbTe+eX+/YfKbEPhDhCdXg+EHw5ZdgHkRJhdW9QpE2a08 TvbBRZUpyfVpIDxoc3EXEFGjZMByEKgFkx8SvDRgYkAegu0JBXPwt6pSOeFn2TqOEyrlw0KD9oy/ vbMy/7ZFaatuoS8CjYC9G2AZXI8c1iXga8/q/G+9B6O/BVSDW2kWKQNgfFCnZFxGT578e1sLAK3m U1n59VQ+VGsPpFCZpRrY87D3gJows9Ffg9gMv1shUPFArcf2W7kXM0vwhr/lS5uh1AoqZcePjvY5 t1N5qpWjekGrmk+1/CgbD0Dtqydy1idlADQhJiuQuSkVB4BGJwWVzZs5qYrtiadFTlCiYoGKnCF9 VKUGd5QN/Ak2UZhsgGNj/0pD3HNjoXvqgRN5qRY5MCu8T7WU6g73s7XFJzszJbyTQi/556JNdvjU /6q2vHBvBNsumHaF/D/doFRABVRAhQEqoAIqDFABFVBhgAqogAoDVEAFVBigAiqgwgAVUAEVBqiA CqgwQAVUQIUBKqACKqDCABVQARUGqIAKqDBABVRAhQEqoAIqDFABFVBhgAqogAoDVEAFVBigAiqg wjJQBaig1FkT2lCXqk12IA9R9yX30RYupDLYsyJl5310o5Pj54PP2611osQ38W+k1nNJD5kF24JP R6t2M7qYjG+6E9DM9imlkqJGq8DASKnVwGrlkSQgtn/2OrStD3tb20jpo1LEt0YckV2LiiyoI4AW 2BFEeRBUcdSr3ndPnJidJ8mDYV+lcpoYscMLYD/67MGTstLpewCTB8dUBCtkl6NTg7GXUlkn99Iw KTb8I0oNZTU9AXOkzvNSDaiWQnl+1owj3vCPBiKheoUTI2A1X2rC7cmLYKUzq6TQXTMDWQhc5j2t 1k3VctaqZZMloFyiibqp3oxqdb8qb6wk+Osm/55as29/qsCURPBys6Grqqbffeoqk24h9ILlFeh8 dX4vD4CaemP1Cl4EF1LhzgctM8dnoTy1DpXs3G8FwKeUU0q7ry8BBgCVXUEI9zCYzAAAAABJRU5E rkJggg==",
    transform: "matrix(0.9881 0 0 -0.9881 3.7063 111.381)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M76.5,0h-70c-2.8,0-5,2.2-5,5v91c0,2.8,2.2,5,5,5h70c2.8,0,5-2.2,5-5V5C81.5,2.2,79.3,0,76.5,0z M69,20 c-4.1,0-7.5-3.4-7.5-7.5S64.9,5,69,5s7.5,3.4,7.5,7.5S73.1,20,69,20z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 69,
    cy: 12.5,
    r: 7.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseTitle);
export default __webpack_public_path__ + "static/media/base-title.91e9ca068691707dd987c4fe6fd534c7.svg";
export { ForwardRef as ReactComponent };